import { IconButton, TableCell, TableRow } from '@mui/material';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { formatCurrency } from '../../helpers/formatCurrency';

interface CommissionSummaryRowProps {
  employeeName: string;
  totalAppointments: number;
  grossRevenue: number;
  cardFees: number;
  netRevenue: number;
  servicesCommissionRate: number;
  commissionAmount: number;
  totalPago?: number;
  pendente?: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const CommissionSummaryRow: React.FC<CommissionSummaryRowProps> = ({
  employeeName,
  totalAppointments,
  grossRevenue,
  cardFees,
  netRevenue,
  servicesCommissionRate,
  commissionAmount,
  totalPago = 0,
  pendente = 0,
  isExpanded,
  onToggle,
}) => {
  return (
    <TableRow
      hover
      onClick={onToggle}
      sx={{ cursor: 'pointer', '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell padding='checkbox'>
        <IconButton size='small'>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </TableCell>
      <TableCell>{employeeName}</TableCell>
      <TableCell align='right'>{totalAppointments}</TableCell>
      <TableCell align='right'>{formatCurrency(grossRevenue)}</TableCell>
      <TableCell align='right'>{formatCurrency(cardFees)}</TableCell>
      <TableCell align='right'>{formatCurrency(netRevenue)}</TableCell>
      <TableCell align='right'>{servicesCommissionRate}%</TableCell>
      <TableCell align='right' sx={{ fontWeight: 600, color: 'primary.main' }}>
        {formatCurrency(commissionAmount)}
      </TableCell>
      <TableCell align='right' sx={{ color: 'text.secondary' }}>
        {formatCurrency(totalPago)}
      </TableCell>
      <TableCell align='right' sx={{ fontWeight: 600, color: pendente > 0 ? 'warning.main' : pendente < 0 ? 'error.main' : 'text.secondary' }}>
        {formatCurrency(pendente)}
      </TableCell>
    </TableRow>
  );
};
